import { useState } from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export function SelectPreviewRoute(): JSX.Element {
  const [value, setValue] = useState<string>("")

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Select</h1>
      </header>

      <Section title="Default">
        <div className="w-72">
          <Select value={value} onValueChange={setValue}>
            <SelectTrigger>
              <SelectValue placeholder="Choose a role" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="viewer" description="Reads reviews. Changes nothing.">
                Viewer
              </SelectItem>
              <SelectItem value="reviewer" description="Disposes findings and sends reports.">
                Reviewer
              </SelectItem>
              <SelectItem value="sme" description="Takes escalations.">
                Specialist
              </SelectItem>
              <SelectItem value="admin" description="Everything, plus users and keys.">
                Admin
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      </Section>

      <Section title="Disabled">
        <div className="w-72">
          <Select disabled>
            <SelectTrigger>
              <SelectValue placeholder="Disabled" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="a">Option A</SelectItem>
              <SelectItem value="b">Option B</SelectItem>
              <SelectItem value="c">Option C</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
